import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { DiskContext } from '../context';
import { useForm } from 'react-hook-form';
import { FileFolderIcon } from '../my-disk/file-icon';
import { isFile } from 'v4/components/utils';
import { getFullFileName } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
export const DiskDeleteFileModal = forwardRef(({ ...props }, ref) => {
  const {
    deleteDisc,
    deleteFileFolder,
    deleteFileFolderLoading,
    selectedFile,
  } = useContext(DiskContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = () => {
    deleteFileFolder(selectedFile);
  };
  const { t } = useTranslator();
  const direction = useDirection();
  return (
    <>
      <Modal isCentered {...deleteDisc}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
          <ModalHeader>
            <HStack alignItems={'flex-start'}>
              <Stack spacing={0} gap={0}>
                <Heading size="md">
                {t('buttons.delete') || "Delete"} {isFile(selectedFile) ? (t('otherModules.file') || 'File') : (t('myDisk.folder') || 'Folder')}
                </Heading>
              </Stack>
            </HStack>
          </ModalHeader>
          <ModalBody>
            <Text>
              {t('otherModules.confirmRemove') || "Are you sure you want to remove"}{' '}
              <Text display="inline" fontWeight="bold">
                "{getFullFileName(selectedFile)}"
              </Text>
              ?
            </Text>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button borderRadius="30px" onClick={deleteDisc?.onClose} variant="secondary">
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                borderRadius="30px"
                isLoading={deleteFileFolderLoading}
                onClick={onSubmit}
                colorScheme="red"
              >
                {t('profile.remove') || "Remove"}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
});
